import React from "react";
import { Search, HelpCircle, Download, Upload, FileText } from "lucide-react"; // npm install lucide-react
import Orders2 from "./Orders2";

const Orders = () => {
  return (
    <div>
    <div className="p-3 md:p-6 bg-gray-50 min-h-screen">
      {/* Header */}
      <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-3">
        <h1 className="text-xl md:text-2xl font-semibold">Orders</h1>

        {/* Top Action Buttons */}
        <div className="flex flex-wrap gap-2 mt-2 md:mt-0">
          <button className="flex items-center gap-1 bg-green-600 hover:bg-green-700 text-white px-3 py-1.5 rounded-md text-sm shadow">
            <Download size={16} /> Export
          </button>
          <button className="flex items-center gap-1 bg-green-500 hover:bg-green-600 text-white px-3 py-1.5 rounded-md text-sm shadow">
            <Upload size={16} /> Import
          </button>
          <button className="flex items-center gap-1 bg-sky-500 hover:bg-sky-600 text-white px-3 py-1.5 rounded-md text-sm shadow">
            <FileText size={16} /> Print PDF
          </button>
        </div>
      </div>

      {/* Search Panel */}
      <div className="bg-white rounded-md shadow p-3 md:p-4">
        {/* Search Header */}
        <div className="flex items-center gap-1 mb-3">
          <Search className="text-gray-600" size={16} />
          <h2 className="font-semibold text-gray-800 text-sm">Search</h2>
        </div>

        {/* Form Fields */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {/* Left Column */}
          <div className="space-y-2.5">
            <FormRow label="Start date" type="date" />
            <FormRow label="End date" type="date" />
            <FormRow label="Warehouse" type="select" options={["All"]} />
            <FormRow label="Product" type="text" />
            <FormRow label="Order statuses" type="select" options={["All"]} multiple />
            <FormRow label="Payment statuses" type="select" options={["All"]} multiple />
            <FormRow label="Shipping statuses" type="select" options={["All"]} multiple />
          </div>

          {/* Right Column */}
          <div className="space-y-2.5">
            <FormRow label="Vendor" type="select" options={["All"]} />
            <FormRow label="Billing phone number" type="text" />
            <FormRow label="Billing email address" type="email" />
            <FormRow label="Billing last name" type="text" />
            <FormRow label="Billing country" type="select" options={["All"]} />
            <FormRow label="Payment method" type="select" options={["All"]} />
            <FormRow label="Order notes" type="text" />

            {/* Go directly to order */}
            <div className="flex items-end gap-2">
              <div className="flex-1">
                <LabelWithHelp label="Go directly to order #" />
                <input
                  type="text"
                  className="border border-gray-300 rounded-md px-2 py-1.5 w-full text-sm outline-none"
                />
              </div>
              <button className="bg-sky-500 hover:bg-sky-600 text-white px-3 py-1.5 rounded-md text-sm shadow">
                Go
              </button>
            </div>
          </div>
        </div>

        {/* Search Button */}
        <div className="mt-4 flex justify-center">
          <button className="flex items-center justify-center gap-1 bg-blue-600 hover:bg-blue-700 text-white px-5 py-1.5 rounded-md text-sm shadow">
            <Search size={16} /> Search
          </button>
        </div>
      </div>
    </div>
     <Orders2 />
    </div>
  );
};

/* --- Helper Components --- */
const LabelWithHelp = ({ label }) => (
  <label className="text-gray-700 font-medium flex items-center gap-1 mb-0.5 text-sm">
    {label} <HelpCircle size={12} className="text-gray-400" />
  </label>
);

const FormRow = ({ label, type, options = [], multiple }) => (
  <div>
    <LabelWithHelp label={label} />
    {type === "select" ? (
      <select
        multiple={multiple}
        className="border border-gray-300 rounded-md px-2 py-1.5 w-full text-sm outline-none bg-white"
      >
        {options.map((opt, i) => (
          <option key={i}>{opt}</option>
        ))}
      </select>
    ) : (
      <input
        type={type}
        placeholder={type === "date" ? "dd-mm-yyyy" : ""}
        className="border border-gray-300 rounded-md px-2 py-1.5 w-full text-sm outline-none"
      />
    )}
  </div>
);

export default Orders;